module.exports = __webpack_public_path__ + "img/Pr23.181cc16b.png";